module.exports = __webpack_public_path__ + "img/empty.fa51b165.png";